/**
 * Catálogo de lead/atendimento (LAIS) — porta `Attendance/constants.js`
 * (`ATTENDANCE_STAGE` + `ATTENDANCE_STAGE_API_KEYS`) e
 * `ClientsCrm/FiltersDrawer/constants.js` do app do corretor QuintoAndar para o
 * vocabulário PT-BR do funil de atendimento usado em `/leads`.
 *
 * Espelha 1x1 `Leads::AttendanceStageResolver` (backend):
 *   sem_visita | uma_ou_duas_visitas | tres_ou_mais_visitas |
 *   proposta_em_andamento | negocio_fechado
 */

export const ATTENDANCE_STAGE = Object.freeze({
  NO_VISIT: 'sem_visita',
  ONE_OR_TWO_VISITS: 'uma_ou_duas_visitas',
  THREE_OR_MORE_VISITS: 'tres_ou_mais_visitas',
  ONGOING_OFFER: 'proposta_em_andamento',
  SIGNED_CCV: 'negocio_fechado',
});

export const ATTENDANCE_STAGE_ORDER = Object.freeze([
  ATTENDANCE_STAGE.NO_VISIT,
  ATTENDANCE_STAGE.ONE_OR_TWO_VISITS,
  ATTENDANCE_STAGE.THREE_OR_MORE_VISITS,
  ATTENDANCE_STAGE.ONGOING_OFFER,
  ATTENDANCE_STAGE.SIGNED_CCV,
]);

export const ATTENDANCE_STAGE_LABELS = Object.freeze({
  [ATTENDANCE_STAGE.NO_VISIT]: 'Sem visita',
  [ATTENDANCE_STAGE.ONE_OR_TWO_VISITS]: '1 ou 2 visitas',
  [ATTENDANCE_STAGE.THREE_OR_MORE_VISITS]: '3 ou mais visitas',
  [ATTENDANCE_STAGE.ONGOING_OFFER]: 'Proposta em andamento',
  [ATTENDANCE_STAGE.SIGNED_CCV]: 'Negócio fechado',
});

export const ATTENDANCE_STAGE_COLORS = Object.freeze({
  [ATTENDANCE_STAGE.NO_VISIT]: 'slate',
  [ATTENDANCE_STAGE.ONE_OR_TWO_VISITS]: 'blue',
  [ATTENDANCE_STAGE.THREE_OR_MORE_VISITS]: 'indigo',
  [ATTENDANCE_STAGE.ONGOING_OFFER]: 'amber',
  [ATTENDANCE_STAGE.SIGNED_CCV]: 'green',
});

export const ATTENDANCE_STAGE_API_KEYS = Object.freeze({
  [ATTENDANCE_STAGE.NO_VISIT]: 'noFinishedVisit',
  [ATTENDANCE_STAGE.ONE_OR_TWO_VISITS]: 'oneOrTwoFinishedVisits',
  [ATTENDANCE_STAGE.THREE_OR_MORE_VISITS]: 'threeOrMoreFinishedVisits',
  [ATTENDANCE_STAGE.ONGOING_OFFER]: 'offerOngoing',
  [ATTENDANCE_STAGE.SIGNED_CCV]: 'ccvSigned',
});

// Opções de filtro/segmentação imobiliária — porta
// `ClientsCrm/FiltersDrawer/constants.js`.
export const CLIENTS_ACTIVITY_VALUES = Object.freeze([
  30, 60, 90, 120, 180, 360,
]);

export const CLIENTS_VISITS_COUNT_VALUES = Object.freeze([
  '1',
  '2',
  '3',
  '4',
  '5+',
]);

export const TIME_OF_SCHEDULE_VALUES = Object.freeze({
  NEW: 'new',
  WITH_VISIT_TODAY: 'with_visit_today',
  WITH_SALE_OFFER: 'with_sale_offer',
});

export const ORDER_CLIENTS_OPTIONS = Object.freeze({
  RECENT_ACTIVITY: 'recent_activity',
  OLDEST_ACTIVITY: 'oldest_activity',
  ALPHABETICAL: 'alphabetical',
});

export const ORDER_CLIENTS_LABELS = Object.freeze({
  [ORDER_CLIENTS_OPTIONS.RECENT_ACTIVITY]: 'Atividade recente',
  [ORDER_CLIENTS_OPTIONS.OLDEST_ACTIVITY]: 'Atividade mais antiga',
  [ORDER_CLIENTS_OPTIONS.ALPHABETICAL]: 'Ordem alfabética',
});

/**
 * Resolve o descritor de estágio (label + cor + chave de API) a partir do
 * estágio retornado pelo backend. Cai em NO_VISIT quando o valor é desconhecido.
 * @param {string} stage
 * @returns {{ stage: string, label: string, color: string, apiKey: string }}
 */
export const getAttendanceStageDescriptor = stage => {
  const resolved = ATTENDANCE_STAGE_ORDER.includes(stage)
    ? stage
    : ATTENDANCE_STAGE.NO_VISIT;

  return {
    stage: resolved,
    label: ATTENDANCE_STAGE_LABELS[resolved],
    color: ATTENDANCE_STAGE_COLORS[resolved],
    apiKey: ATTENDANCE_STAGE_API_KEYS[resolved],
  };
};

export default ATTENDANCE_STAGE;
